import {
  // createAction,
  handleActions
} from "redux-actions";
import {
  SET_LOADING,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_PRIMARY_REVENUE_CATEGORIES_SUCCESS,
  FETCH_PRICING_OPTION_SUCCESS,
  SET_OPTION_LOADING,
  UPDATE_PRICING_OPTION_SUCCESS,
  SEARCH_PRICING_OPTIONS_SUCCESS,
  SET_SEARCH_PARAMS,
  TOGGLE_SHOW_EMPTY_SUCCESS,
  TOGGLE_SHOW_INACTIVE_SUCCESS,
  FETCH_DATA_ERROR,
  SET_MODAL_LOADING,
  CLEAR_ERRORS_SUCCESS,
  SET_TAGS_LOADING
} from "../sagas/pricingOptionsMapping/pricingOptionsMapping";
// Name Spaced Action Types
export const actions = {
  SET_LOADING,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_PRIMARY_REVENUE_CATEGORIES_SUCCESS,
  FETCH_PRICING_OPTION_SUCCESS,
  SET_OPTION_LOADING,
  UPDATE_PRICING_OPTION_SUCCESS,
  SEARCH_PRICING_OPTIONS_SUCCESS,
  SET_SEARCH_PARAMS,
  TOGGLE_SHOW_EMPTY_SUCCESS,
  TOGGLE_SHOW_INACTIVE_SUCCESS,
  FETCH_DATA_ERROR,
  SET_MODAL_LOADING,
  CLEAR_ERRORS_SUCCESS,
  SET_TAGS_LOADING
};

// createAction is a lib for creating FSAs
// see https://github.com/acdlite/flux-standard-action, for info in the flux standard action
export const actionCreators = {};

export const initialState = {
  currentUser: {},
  showEmpty: true,
  showInactive: false,
  primaryRevenueCategories: {
    result: [],
    tag_names: [],
    tag_changes: []
  },
  searchParams: {
    query: "",
    active: false
  },
  searchedPricingOptions: { data: { pricing_options: [] } },
  pricingOptions: [],
  isLoading: false,
  tagsLoading: false,
  optionLoading: {
    loading: false,
    id: null
  },
  modalLoading: false,
  haveError: false,
  error: ""
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_TAGS_LOADING]: (state, action) => ({
      ...state,
      tagsLoading: action.payload
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload || state.currentUser
    }),
    [FETCH_PRIMARY_REVENUE_CATEGORIES_SUCCESS]: (state, action) => ({
      ...state,
      primaryRevenueCategories: action.payload
    }),
    [FETCH_PRICING_OPTION_SUCCESS]: (state, action) => ({
      ...state,
      pricingOptions: action.payload
    }),
    [SEARCH_PRICING_OPTIONS_SUCCESS]: (state, action) => ({
      ...state,
      searchedPricingOptions: action.payload
    }),
    [SET_SEARCH_PARAMS]: (state, action) => ({
      ...state,
      searchParams: action.payload
    }),
    [UPDATE_PRICING_OPTION_SUCCESS]: (state, action) => ({
      ...state,
      pricingOptions: action.payload
    }),
    [SET_OPTION_LOADING]: (state, action) => ({
      ...state,
      optionLoading: action.payload
    }),
    [TOGGLE_SHOW_EMPTY_SUCCESS]: (state, action) => ({
      ...state,
      showEmpty: action.payload
    }),
    [TOGGLE_SHOW_INACTIVE_SUCCESS]: (state, action) => ({
      ...state,
      showInactive: action.payload
    }),
    [FETCH_DATA_ERROR]: (state, action) => ({
      ...state,
      haveError: true,
      error: action.payload
    }),
    [SET_MODAL_LOADING]: (state, action) => ({
      ...state,
      modalLoading: action.payload
    }),
    [CLEAR_ERRORS_SUCCESS]: state => ({
      ...state,
      haveError: false,
      error: ""
    })
  },
  initialState
);
